import './vertical_radio_group.scss';
import classNames from 'classnames';
import React from 'react';
import { FormField } from '../../../model/form';
import { SpacingSizes, Stack } from '../../Stack/Stack';
import { Radio } from './Radio';

interface RadioOption<T> {
  label: string;
  value: T;
  checked?: boolean;
  disabled?: boolean;
}

interface Props<T extends string> extends FormField<T | null> {
  options: RadioOption<T>[];
  name: string;
  layout?: 'row' | 'list';
  stackSize?: SpacingSizes;
}

// TODO: #2366 - Check unnecessary props
export function VerticalRadioGroup<T extends string>({
  onChange,
  name,
  value,
  options,
  layout = 'row',
  label,
  description,
  stackSize = 'lg',
}: Props<T>): JSX.Element {
  return (
    <Stack size="xxs">
      <div>
        {label && <div className="vertical-radio-group__label">{label}</div>}
        {description && <div className="vertical-radio-group__description">{description}</div>}
      </div>
      <Stack
        className={classNames('vertical-radio-group', `vertical-radio-group--${layout}`)}
        line={layout === 'row'}
        size={stackSize}
      >
        {options.map((option) => (
          <Radio<T>
            name={name}
            key={option.label}
            label={option.label}
            value={option.value}
            checked={option.checked || option.value === value}
            onChange={(val) => onChange?.(val)}
            disabled={option.disabled}
          />
        ))}
      </Stack>
    </Stack>
  );
}
